export default "__VITE_ASSET__b88db54f__"